import { Url } from './constantUrl';
import { HTTP_STATUS } from '../constants/httpstatus/HttpsStatus';
import {
    CREATE_AREA_EXECUTIVE_REQUEST,
    CREATE_AREA_EXECUTIVE_SUCCESS,
    CREATE_AREA_EXECUTIVE_FAILURE,
    FETCH_AREA_EXECUTIVE_REQUEST,
    FETCH_AREA_EXECUTIVE_SUCCESS,
    FETCH_AREA_EXECUTIVE_FAILURE,
    DELETE_AREA_EXECUTIVE_REQUEST,
    DELETE_AREA_EXECUTIVE_SUCCESS,
    DELETE_AREA_EXECUTIVE_FAILURE,
    AREA_EXECUTIVE_DETAIL_REQUEST,
    AREA_EXECUTIVE_DETAIL_SUCCESS,
    AREA_EXECUTIVE_DETAIL_FAILURE,
    UPDATE_AREA_EXECUTIVE_SUCCESS,
    UPDATE_AREA_EXECUTIVE_FAILURE,
    TOGGLE_AREA_EXECUTIVE_STATUS_SUCCESS,
    TOGGLE_AREA_EXECUTIVE_STATUS_FAILURE
} from './types';
import { makeApiCall } from './makeApiCall';

// Fetch Area Executive List
export const fetchAreaExecutedListAction = (searchInput = '', page = 1, pageSize) => async (dispatch) => {
    return makeApiCall({
        method: 'GET',
        endpoint: Url.AREA_EXECUTIVE_LIST,
        params: {
            ...(searchInput && { search_data: searchInput }),
            page,
            ...(pageSize && { page_size: pageSize }),
        },
        dispatch,
        requestType: FETCH_AREA_EXECUTIVE_REQUEST,
        successType: FETCH_AREA_EXECUTIVE_SUCCESS,
        failureType: FETCH_AREA_EXECUTIVE_FAILURE,
    });
};

// Create Area Executive
export const createAreaExecutiveAction = (areaExecutiveData) => async (dispatch) => {
    return makeApiCall({
        method: 'POST',
        endpoint: Url.CREATE_AREA_EXECUTIVE,
        data: areaExecutiveData,
        dispatch,
        requestType: CREATE_AREA_EXECUTIVE_REQUEST,
        successType: CREATE_AREA_EXECUTIVE_SUCCESS,
        failureType: CREATE_AREA_EXECUTIVE_FAILURE,
    });
};

// Delete Area Executive
export const deleteAreaExecutiveAction = (areaExecutiveId) => async (dispatch) => {
    return makeApiCall({
        method: 'DELETE',
        endpoint: `${Url.DELETE_AREA_EXECUTIVE}/${areaExecutiveId}`,
        dispatch,
        requestType: DELETE_AREA_EXECUTIVE_REQUEST,
        successType: DELETE_AREA_EXECUTIVE_SUCCESS,
        failureType: DELETE_AREA_EXECUTIVE_FAILURE,
    });
};

// Get Area Executive Details
export const getAreaExecutiveDetailAction = (areaExecutiveId) => async (dispatch) => {
    return makeApiCall({
        method: 'GET',
        endpoint: `${Url.GET_AREA_EXECUTIVE_DETAILS}/${areaExecutiveId}`,
        dispatch,
        requestType: AREA_EXECUTIVE_DETAIL_REQUEST,
        successType: AREA_EXECUTIVE_DETAIL_SUCCESS,
        failureType: AREA_EXECUTIVE_DETAIL_FAILURE,
    });
};

// Update Area Executive
export const updateAreaExecutiveAction = (areaExecutiveId, payload) => async (dispatch) => {
    return makeApiCall({
        method: 'PUT',
        endpoint: `${Url.UPDATE_AREA_EXECUTIVE}/${areaExecutiveId}`,
        data: payload,
        dispatch,
        requestType: AREA_EXECUTIVE_DETAIL_REQUEST,
        successType: UPDATE_AREA_EXECUTIVE_SUCCESS,
        failureType: UPDATE_AREA_EXECUTIVE_FAILURE,
    });
};

//switch toggle for area executive
export const toggleAreaExecutiveStatusAction = (areaExecutiveId, isActive) => async (dispatch) => {
    const endpoint = `${Url.AREA_EXECUTIVE_ACTIVATE_DEACTIVATE_SWITCH}/${areaExecutiveId}`;
    const data = { is_active: isActive };
    return await makeApiCall({
        method: 'POST',
        endpoint,
        data: data,
        dispatch,
        requestType: '',
        successType: TOGGLE_AREA_EXECUTIVE_STATUS_SUCCESS,
        failureType: TOGGLE_AREA_EXECUTIVE_STATUS_FAILURE,
    });
};
